export enum InstrumentDropdownNameEnum {
  NAME_ASC = 'Name: A-Z',
  NAME_DESC = 'Name: Z-A',
  CREATED_NEWEST = 'Created: Newest First',
  CREATED_OLDEST = 'Created: Oldest First',
}
